<template>
  <div class="search_box">
    <div class="search_header">
      <div class="search_ipt">
        <input
          type="text"
         :placeholder="inputVal"
          v-model="key"
          @input='inputFun'
        />
      </div>
    </div>
    <div class="search_main">
      <span v-if="lists.length > 0" class="end_title">搜索结果</span>
        <template v-if="lists.length > 0">
            <div class="search_item" v-for="(item,index) in lists" :key="index" @click="backPage(item)">
                <span class="item_title">{{item.userName | nameType(activeTab)}}({{item.s_phone}})</span>
                <div class="com">
                    <span class="com_left">公司</span>
                    <span class="com_right">{{item.company}}</span>
                </div>
                <div class="com">
                    <span class="com_left">地址</span>
                    <span class="com_right">{{item.address}}</span>
                </div>
            </div>
        </template>
    </div>
    <!-- 搜索结果显示 -->
    <span class="search_status" v-if="searchEnd == '1' && key.length != '0'">找不到与“{{key}}”匹配的内容</span>
    <div class="search_status2" v-if="searchEnd == '2' && key.length != '0'">
      <span>正在搜索...</span>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import {
  queryExamineTenant
} from "../../utils/api";
import util from "../../utils/util";
import storage from "../../utils/storage";
let timer = ''
export default {
  watch: {
    searchData: function() {
      this.getData();
    }
  },
  data() {
    return {
        searchEnd: 0, //搜索结果状态
        key: '', //input值
        focus: true,
        activeTab: 1, //0拜访 1邀请
        lists: [],
        inputVal: '搜索手机号'
    };
  },
  created(){
      console.log(this.$route.query)
      this.activeTab = this.$route.query.activeTab
    if (this.$route.query.activeTab == 1) {
        document.title = '选择我的信息'
        this.inputVal = '搜索姓名'
    }else{
        document.title = '搜索手机号'
        this.inputVal = '搜索手机号'
    }
  },
  activated() {
    console.log(this.activeTab)
    if(this.activeTab  == 1){
      this.getData();
    }
  },
  components: {},
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  filters: {
      nameType(val,activeTab) {
        if (activeTab == 1) {
            return val
        } else {
            var arr = val.split("");
            for (var i = 0; i < arr.length; i++) {
            if (i > 0) {
                arr[i] = '*'
            }
            }
            return arr.join("")
        }
      },
  },
  methods: {
    getData() {
      let that = this;
      let params = {
        examineUserName: this.key,
        marketId: this.common.marketInfo.id,
        visitorMode: Number(this.$route.query.activeTab),
        userId: this.common.userId
      };
      util.showLoading("加载中...");
      queryExamineTenant(params).then(res => {
        console.log(res);
        util.hideLoading();
        let data = res.body.tenantList;
        if (data.length > 0) {
            data.forEach(item => {
                item.s_phone = item.phone.substr(0, 3) + '****' + item.phone.substr(7)
            })
            that.searchEnd = 0;
            that.lists = data;
            console.log(data)
        } else {
            that.searchEnd = 1;
        }
      });
    },
    backPage(item){
      storage.set("userInfo",JSON.stringify(item))
      this.$router.go(-1)
    },
    inputFun(){//键盘输入时触发input事件
      clearTimeout(timer);
      var that = this;
      that.lists = []
      if(that.key.trim().length != 11 && this.activeTab == 0){
        return ;
      }
      if (that.key.length == 0) {//如果输入框为空
        that.searchEnd = 0
      }else{
        this.searchEnd = 2
        timer = setTimeout(function(){
          that.getData();
        },800)
      }
    },
  }
};
</script>
<style lang="less" scoped>
@import '../../assets/css/common.less';
.search_box {
  background: #fff;
}
.search_header {
  width: 100%;
  height: 100px;
  background: #fff;
  position: fixed;
  top: 0;
  left: 0;
}
.search_ipt {
  height: 68px;
  background: #f4f4f4;
  display: flex;
  flex-direction: row;
  border-radius: 8px;
  margin: 16px 28px;
}
.search_ipt input {
  background: transparent url("../../assets/images/search.png") 14px 12px no-repeat;
  background-size:44px 44px;
  font-size: 28px;
  color: #333;
  height: 68px;
  padding-left:74px;
  flex:1;
}
.search_main {
  margin-top: 100px;
  background: #fff;
}
.end_title {
  display: block;
  background: #f8f8f8;
  padding-left: 28px;
  font-size: 28px;
  color: #999;
  height: 68px;
  line-height: 68px;
}
.search_item{
  padding:28px;
  .borderB();
}
.item_title{
  font-size:28px;
  color:#333;
  line-height:40px;
  margin-bottom:8px;
}
.com{
  display:flex;
  flex-direction:row;
}
.com_left{
  margin-right:28px;
  color:#999;
  font-size:24px;
  line-height:34px;
}
.com_right{
  flex:1;
  color:#333;
  font-size:24px;
  line-height:34px;
}
/*search_status*/
.search_status {
  display: block;
  text-align: center;
  font-size: 28px;
  line-height: 40px;
  margin: 44px auto;
  color: #999;
}
.search_status2 {
  display: flex;
  text-align: center;
  margin: 30px auto;
  justify-content: center;
}
.search_status2 img {
  display: block;
  width: 28px;
  height: 28px;
  margin-right: 8px;
  margin-top: 6px;
}
.search_status2 text {
  font-size: 28px;
  line-height: 40px;
  color: #888;
}
</style>
